import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as CustomTagActions from 'actions/custom_tags'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  show: false,
  selectedGroupId: 0
})

export default handleActions({
  [CustomTagActions.showAssignCustomTagsToGroupDialog]: (state, { payload: groupId }) => state.merge({
    show: true,
    selectedGroupId: groupId
  }),
  [CustomTagActions.hideAssignCustomTagsToGroupDialog]: () => initialState,

  [AppActions.resetState]: () => initialState
}, initialState)
